import cx from 'classnames';
import {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {Card} from '~/common/canvas/Card/Card';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';
import {Envelope} from '~/CreateFabricInvitation/components/Envelope/Envelope';
import {selectFabricArt} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {useStamp} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/actions/useStamp';
import {EventCreateStickerContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Sticker/EventCreateStickerContext';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';

import {largishAndUp} from '~libSass/base/_exports.sass';
import './Stamp.sass';

export const Stamp = () => {
  const {canvas} = useContext(EventCreateStickerContext);
  const fabricArt = useSelector(selectFabricArt);
  const {selectedStamp} = useStamp();
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  const refreshCanvasDimensions = useCallback(() => {
    canvas?.setCurrentDimensions();
  }, [canvas]);

  return (
    <div
      className={cx('card-template', 'stamp', {
        'onestep-edit-ABTest__card-wrapper': isInEditButtonTest,
      })}
    >
      <div className="stamp__images">
        <Card
          className="stamp__images__card"
          fabricArt={fabricArt}
          redirectTo={isDesktop ? Sections.CARD_DESIGN : null}
          parentNode={`${!isDesktop ? 'create-container' : ''}`}
        />
        <Envelope
          type="image"
          className="stamp__images__envelope"
          id="canvas__wrapper__stickers"
          selectedStamp={selectedStamp?.image}
          message="Guest's name will go here"
          canvas
          onLoad={refreshCanvasDimensions}
          forceShowEnvelope
        />
      </div>
    </div>
  );
};
